import { call, put, takeEvery } from 'redux-saga/effects';
import { captureException } from '@sentry/react';
import { api, daUtil } from "../../../api";
import {
  DISPATCH_MAIN_MODAL_PRELOAD_ISO_BAG,
  DISPATCH_MAIN_MODAL_SHOW,
  DISPATCH_MODAL_DEPOSIT_DRIVER,
  DISPATCH_MODAL_DEPOSIT_DRIVERS,
  DISPATCH_MODAL_DOCK_ROUTE,
  DISPATCH_MODAL_OPTIMIZE_DOCK,
  DISPATCH_MODAL_UBERDIRECT_BATCH,
  // DISPATCH_MODAL_OPTIMIZE_DOCK_LOADED,
} from "../actions/modal";


function* modalIsobagPreload(action) {
  let driverList = yield call(daUtil.get, `/drivers/`);
  yield put({type: DISPATCH_MAIN_MODAL_SHOW, modalData: {modalType: "driver_iso_bag", driverList: driverList}});
}

function* modalDepositDriver(action) {
  yield put({type: DISPATCH_MAIN_MODAL_SHOW, modalData: {modalType: DISPATCH_MODAL_DEPOSIT_DRIVER, driver: action.driver}});
}

function* modalDepositDrivers(action) {
  yield put({type: DISPATCH_MAIN_MODAL_SHOW, modalData: {modalType: DISPATCH_MODAL_DEPOSIT_DRIVERS}});
}

function* modalCompareDockRoute(action) {
  try {
    const url = `route/${action.dock.id}/?parent_order=0&products=0`;
    let dock = yield call(daUtil.get, url);

    yield put({type: DISPATCH_MAIN_MODAL_SHOW, modalData: {
      modalType: DISPATCH_MODAL_DOCK_ROUTE,
      dock: dock,
      routes: dock.routes,
    }});
  } catch (exception) {
  }

}

function* modalOptimizeDockRoute(action) {
  try {
    const optimizer = action.optimizer;
    const url = `route/${action.dock.id}/optimize/?optimizer=${optimizer}&parent_order=0&products=0`;
    const dock = yield call(daUtil.post, url);

    yield put({
      type: DISPATCH_MAIN_MODAL_SHOW, modalData: {
        modalType: DISPATCH_MODAL_DOCK_ROUTE,
        dock: dock,
        routes: dock.routes,
      }
    });
  } catch (exception) {
  }
}

function* modalUberDirectBatch(action) {
  try {
    const { dock } = action;
    // Show modal immediately with loading state
    yield put({
      type: DISPATCH_MAIN_MODAL_SHOW,
      modalData: {
        modalType: 'uberdirect_batch',
        dock,
        loadingWindows: true,
        sending: false,
        windows: [],
      }
    });

    // Fetch available windows
    const response = yield call(api.getUberDirectWindows, dock.id);
    const windows = response.dropoff_windows || [];

    // Update modal with windows data
    yield put({
      type: DISPATCH_MAIN_MODAL_SHOW,
      modalData: {
        modalType: 'uberdirect_batch',
        dock,
        loadingWindows: false,
        sending: false,
        windows,
      }
    });
  } catch (exception) {
    captureException(exception)
    const errorMessage = (exception && exception.response && exception.response.data && (
      exception.response.data.error || exception.response.data.message
    )) || exception.message || 'Erreur lors du chargement des créneaux';

    // Show modal with error state
    yield put({
      type: DISPATCH_MAIN_MODAL_SHOW,
      modalData: {
        modalType: 'uberdirect_batch',
        dock: action.dock,
        loadingWindows: false,
        sending: false,
        windows: [],
        error: errorMessage,
      }
    });
  }
}

export const modalSagas = [
  takeEvery(DISPATCH_MAIN_MODAL_PRELOAD_ISO_BAG, modalIsobagPreload),
  takeEvery(DISPATCH_MODAL_DEPOSIT_DRIVER, modalDepositDriver),
  takeEvery(DISPATCH_MODAL_DEPOSIT_DRIVERS, modalDepositDrivers),
  takeEvery(DISPATCH_MODAL_DOCK_ROUTE, modalCompareDockRoute),
  takeEvery(DISPATCH_MODAL_OPTIMIZE_DOCK, modalOptimizeDockRoute),
  takeEvery(DISPATCH_MODAL_UBERDIRECT_BATCH, modalUberDirectBatch),
];
